import React from 'react';
import classNames from 'classnames';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Header from './Header';
import Loader from '../../../components/Loader';

export default function NetworkSite(props) {
  const { site, network, className, children } = props;

  const networkSite = useConnect('networkSite.first', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          networkId: network?.id
        }
      }
    }
  });

  if (networkSite.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      // 'hover:bg-cs-orange-50 cursor-pointer',
      className
    )}>
      <div className="flex flex-col py-4 px-4 space-y-2">
        <Header
          networkSite={networkSite}
          site={site}
          network={network}
        />
      </div>
    </div>
  );
}
